export default __webpack_public_path__ + "static/media/rising_cost.e12e62a7.svg";